import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import BugsnagPerformance from "@bugsnag/browser-performance";

export function initBugsnag() {
  const apiKey = import.meta.env.VITE_BUGSNAG_API_KEY;

  if (!apiKey) {
    if (import.meta.env.MODE === "development") {
      console.log("Bugsnag API key not configured");
      return null;
    }
    throw new Error("Bugsnag API key is required in production/staging");
  }

  Bugsnag.start({
    apiKey: apiKey,
    plugins: [new BugsnagPluginReact()],
    appVersion: import.meta.env.VITE_APP_VERSION || new Date().toISOString(),
    releaseStage: import.meta.env.MODE,
    enabledReleaseStages: ["production", "staging"],
    collectUserIp: false,
    maxBreadcrumbs: 40,
  });

  BugsnagPerformance.start({
    apiKey: apiKey,
    releaseStage: import.meta.env.MODE,
    enabledReleaseStages: ["production", "staging"],
  });

  return Bugsnag;
}

export default Bugsnag;
